import  { useCallback, useEffect } from 'react';
import {
    Box,
} from '@material-ui/core';
import ReactFlow, {
    // useNodesState,
    // useEdgesState,
    Background,
    BackgroundVariant,
    MiniMap,
    // useStoreApi,
    // useOnSelectionChange,
    useReactFlow,
    ReactFlowProvider,
    Controls,
} from 'reactflow';
import Sidebar from './Sidebar';
import 'reactflow/dist/style.css';
import './Styles/root.css';
//Estilos minimap
import './Styles/minimap.css';
// Custom Hooks
import useDeviceDetect from "../../hooks/useDeviceDetect";
//Models.
const modelsContext = require.context('./Models', false, /\.js$/);
const nodeTypes = modelsContext.keys().reduce((acc, path) => {
    const moduleName = path.replace('./', '').replace('.js', '');
    acc[moduleName] = modelsContext(path).default;
    return acc;
}, {});

const Flow = ({
    nodes, edges, onNodesChange, onEdgesChange, onSelectionDrag,
    setReactFlowInstance, onConnect, onConnectEnd, onDrop, onConnectStart, resetZoom, componentType,
}) => {
    const proOptions = { hideAttribution: true }
    const { isMobile } = useDeviceDetect(930);
    const reactFlow = useReactFlow();
    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);

    //Coloca el zoom en cero cuando importo un diagrama nuevo.
    useEffect(() => {
        reactFlow.zoomTo(0.5)
        // eslint-disable-next-line
    }, [resetZoom])

    return (
        <ReactFlow
            fitView
            selectionOnDrag={true} // Permite la selección al arrastrar        
            panOnDrag={isMobile ? true : [1, 2]} // el 1 habilita el click scroll de el mause para q no bloquee la pantalla.
            // panOnDrag={true}
            // paneMoveable={true}
            zoomOnPinch={false}
            nodesDraggable={componentType !== 'Automate-24V-4M' ? true : false}        // Desactiva el arrastre de nodos
            zoomOnDoubleClick={false}
            // panOnScrollSpeed={3}
            // onElementsRemove={onElementsRemove}
            //Habilita el tipo de movimiento q podes realizar con el evento mover.
            //Activa mover la pantalla con el click de la rueda de el raton.
            // panOnScroll={true}
            // panOnScrollMode={'free'}
            //Desactiva q muevas con el click de el raton.
            // paneMoveable={false}
            deleteKeyCode={["Delete"]}
            // multiSelectionKeyCode={null} // Deshabilita la selección múltiple con teclas
            // selectionKeyCode={['Space']}   
            // zoomActivationKeyCode={['Meta'] }  
            onInit={setReactFlowInstance}
            onDrop={onDrop}
            onDragOver={onDragOver}
            proOptions={proOptions}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={(params) => onConnect(params, nodes)}
            onConnectStart={(params) => onConnectStart(params, nodes)}
            onConnectEnd={onConnectEnd}
            nodeTypes={nodeTypes}
            onSelectionChange={onSelectionDrag}
        // zoomOnDoubleClick={true}
        // onEdgeClick={onEdgeClick}
        // onNodeDoubleClick={() => { console.log('dobleclick') }}
        // onNodeClick={() => console.log('un solo click')}      
        >
            <Controls />
            <Background
                variant={BackgroundVariant.Cross}
                gap={10}
            />
            {
                !isMobile &&
                <MiniMap
                    className="custom-minimap"
                    // nodeComponent={MiniMapNode}
                    nodeStrokeWidth={5}
                    zoomable={true}
                    pannable={true}
                    zoomStep={2}
                    offsetScale={5}
                />
            }
        </ReactFlow >
    );
};

const Root = ({
    nodes, onNodesChange, edges, onEdgesChange, onSelectionDrag, setReactFlowInstance,
    componentType, onConnect, onConnectEnd, onDrop, onConnectStart, isMobile, resetZoom, valueSelectorModel, setValueSelectorModel
}) => (
    <Box style={{
        height: '100%',
        display: 'flex',
    }} className="dndflow">
        <ReactFlowProvider>
            {/* Drag and drop */}
            {
                !isMobile && componentType !== 'Automate-24V-4M' &&
                < Sidebar
                    componentType={componentType}
                    valueSelectorModel={valueSelectorModel}
                    setValueSelectorModel={setValueSelectorModel}
                />
            }
            {/* Componente flow recursivo */}
            <Flow
                componentType={componentType}
                resetZoom={resetZoom}
                onSelectionDrag={onSelectionDrag}
                edges={edges}
                nodes={nodes}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={onConnect}
                onConnectEnd={onConnectEnd}
                onConnectStart={onConnectStart}
                onDrop={onDrop}
                setReactFlowInstance={setReactFlowInstance}
                valueSelectorModel={valueSelectorModel}
                setValueSelectorModel={setValueSelectorModel}

            />
        </ReactFlowProvider>
    </Box>
);
export default Root